var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "ml-2": "" } },
    [
      _c(
        "v-list",
        {
          staticClass: "document--categories",
          staticStyle: { background: "none !important" },
          attrs: { "two-line": "" }
        },
        [
          _vm._l(_vm.coTypes, function(item, index) {
            return [
              item.header
                ? _c(
                    "h1",
                    {
                      key: item.header,
                      staticClass: "document--categories__header ml-3"
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(item.header) + "\n        "
                      )
                    ]
                  )
                : item.divider
                ? _c("v-divider", { key: index, attrs: { inset: item.inset } })
                : [
                    !_vm.coLoader
                      ? _c(
                          "v-list-tile",
                          {
                            key: item.fk_attachment_type,
                            staticClass: "pl-3 mt-2 mb-2",
                            attrs: { avatar: "" },
                            on: {
                              click: function($event) {
                                _vm.handleDocumentClick(item.fk_attachment_type)
                              }
                            }
                          },
                          [
                            _c("v-list-tile-avatar", { staticClass: "mr-3" }, [
                              _c("img", {
                                attrs: {
                                  src: item.totalDocuments
                                    ? item.icon
                                    : item.icon_grey
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                _c("v-list-tile-title", [
                                  _c("b", [
                                    _vm._v(_vm._s(_vm.getDocumentTitle(item)))
                                  ])
                                ]),
                                _vm._v(" "),
                                item.totalDocuments
                                  ? _c("v-list-tile-sub-title", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getDocumentSubTitle(item)
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _c("document-categories-loader")
                  ]
            ]
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41902792", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41902792","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/documents/document-categories-list/template.html
// module id = null
// module chunks = 